import { useCallback, useContext } from 'react'
import { NavbarContext } from '../../Context/NavbarContext'
import { useEffect } from 'react'
import { Platform } from '../../Context/PlatformContext'
import Ask from '../Ask/Ask2'
import { GetStartedContext } from '../../Context/GetStartedContext'
import GetStarted from '../GetStartedChecklist/GetStarted'
import { useSelector } from 'react-redux'
const { Drawer, DrawerContent, IconButton, DrawerBody, Image, Button, Text, AccordionButton, Accordion, AccordionItem, AccordionPanel, Flex, Box, DrawerOverlay } = require('@chakra-ui/react')
const { Outlet, useNavigate } = require('react-router-dom')

const NavbarButton = ({isActive, text, iconSrc, ...props}) => {
  return (
    <Button
      justifyContent='flex-start' 
      alignItems='center' 
      px={3} 
      py={'10.5px'}
      colorScheme={ isActive ? 'brandGrey' : 'brandWhite'}
      variant='solid'
      {...props}
    >
      {iconSrc ? <Image boxSize={5} src={iconSrc} mr={2} /> : <></>}
      <Text 
        fontWeight={ isActive ? 'bold' : 'normal'}
        color='brandTextBlack' 
        fontSize='md'
      >
        {text}
      </Text>
    </Button>
  )
}

export const generateLink = (id1, id, name) => {
  if (id1 === 'dashboardFunctions') {
    return `/transcripts-summaries/dashboard?name=function_${name.replace(
      ' ',
      '-'
    )}`
  }

  if (id1 === 'dashboardTags') {
    return `/transcripts-summaries/dashboard?name=tag_${id.substring(4)}___${name.replace(
      ' ',
      '-'
    )}`
  }

  if (id1 === 'recurringEvents') {
    return `/transcripts-summaries/dashboard?name=rec_${id.substring(4)}___${name.replace(
      ' ',
      '-'
    )}`
  }
}

const NavbarLayout = () => {
  const { getStarted, currentStep, setCurrentStep } = useContext(GetStartedContext)
  const user = useSelector((state) => state?.user?.data)

  const {isNavbarOpen, toggleNavbar, currentPath, dashboardFunctions, recurringEvents, dashboardTags, setCurrentPath, searchIsOpen, setSearchIsOpen} = useContext(NavbarContext)
  const navigate = useNavigate()
  
  const platform = useContext(Platform)

  const handleKeyDown = useCallback((event) => {
    if (
      (platform === 'Mac' &&
        event.metaKey &&
        event.key.toUpperCase() === 'K') ||
      (platform === 'Windows' &&
        event.ctrlKey &&
        event.key.toUpperCase() === 'G')
    ) {
      event.preventDefault()
        // if ( currentStep === 3.5) return
        // if (currentStep === 2) {
        //   setCurrentStep(2.5)
        // }
        setSearchIsOpen(true)
      }
      // if (event.key.toUpperCase() === 'ESCAPE') {
      //   setSearchIsOpen(false)
      // }
    },
    [currentStep]
  )

  useEffect(() => {
    document.removeEventListener('keydown', handleKeyDown)  
    
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  
  }, [currentStep])


  return (
    <>
      <Drawer 
        isOpen={isNavbarOpen}
        onClose={() => toggleNavbar()}
        placement='left'
        blockScrollOnMount={false}
        trapFocus={false}
        variant='nonblocking'
      >
        <DrawerOverlay bg='transparent' onClick={() => toggleNavbar()} />
        <DrawerContent
          boxShadow={`
          -32px 186px 75px rgba(0, 0, 0, 0.01), 
          -18px 104px 64px rgba(0, 0, 0, 0.03), 
          -8px 46px 47px rgba(0, 0, 0, 0.05), 
          -2px 12px 26px rgba(0, 0, 0, 0.06), 
          0px 0px 0px rgba(0, 0, 0, 0.06)
        `}
        >
          <DrawerBody
            px={3}
            py={4}
            display='flex'
            flexDirection='column'
          >
            <IconButton
              icon={<Image src='/assets/icons/cancel.svg' />}
              onClick={() => toggleNavbar()}
              colorScheme='brandWhite'
              p='4.5px'
              minW={0}
              h='auto'
              mt={1}
              ml={3}
              alignSelf='flex-start'
            />

            <Flex
              mt={5}
              alignItems='stretch'
              gap={0}
              direction='column'
              flex={1}
            >

              <Button
                justifyContent='flex-start' 
                alignItems='center' 
                px={3} 
                py={'10.5px'}
                colorScheme={'brandGrey'}
                variant='solid'
                mb={5}
                onClick={() => toggleNavbar() || setSearchIsOpen(true)}
              >
                <Image boxSize={5} src={'/assets/icons/ask.svg'} mr={2} />
                <Text 
                  fontWeight={ 'bold'}
                  color='brandTextBlack' 
                  fontSize='md'
                >
                  Ask
                </Text>
                <Flex
                  bg='#F7FAFC'
                  h='24px'
                  ml='auto'
                  px={1}
                  alignItems='center'
                  justifyContent='center'
                  borderRadius='6px'
                  border='1px solid #E2E8F0'
                >
                  <Text
                    color='#222222'
                    fontWeight='700'
                    fontSize='12px'
                    lineHeight='16px'
                  >
                    {platform === 'Mac' ? '⌘ K' : 'Ctrl G'}
                  </Text>
                </Flex>
              </Button>
              
              {[
                {id: 'transcripts-summaries', text: 'Meetings', iconSrc: '/assets/icons/meetingsDrawer.svg'}
              ].map(({id, text, iconSrc}) => (
                <NavbarButton 
                  key={id} 
                  isActive={currentPath[0] === id} 
                  text={text} 
                  iconSrc={iconSrc}
                  onClick={() => {
                    navigate(`/${id}`) 
                    setCurrentPath([id])
                  }}
                />
              ))}

              {/* <Accordion allowMultiple mt={2}>
                {[{id: 'dashboardFunctions', title: 'Functions', items: dashboardFunctions},
                  {id: 'dashboardTags', title: 'Tags', items: dashboardTags},
                  {id: 'recurringEvents', title: 'Recurrent Meetings', items: recurringEvents},
                ].map(({id: id1, title, items}) => (
                  <AccordionItem key={id1}>
                    {({isExpanded}) => (
                      <>
                        <AccordionButton 
                          color='brandTextBlack' 
                          justifyContent='flex-start' 
                          alignItems='center' 
                          px={3} 
                          py={2}
                          minH={0}
                          borderRadius='md'
                          colorScheme={'brandWhite'}
                          variant='solid'
                        >
                          { !items || !items.length ? <Box w={5} mr={2} /> : isExpanded ? (
                            <Image boxSize={5} src='/assets/icons/chevronUp.svg' mr={2} />
                          ): (
                            <Image boxSize={5} src='/assets/icons/chevronDown.svg' mr={2} />
                          )}
                          <Text color='brandTextBlack' fontSize='md'>{title}</Text>
                        </AccordionButton>
                        <AccordionPanel color='brandTextBlack' p={0} m={0}>
                          <Flex
                            alignItems='stretch'
                            gap={0}
                            direction='column'
                          >
                            {items.map(({id, name}) => (
                              <Button
                                key={`${id1}-${id}`}
                                color='brandTextBlack' 
                                justifyContent='flex-start' 
                                alignItems='center' 
                                px={3} 
                                py={'10.5px'}
                                colorScheme={'brandWhite'}
                                onClick={() => {
                                  const path = generateLink(id1, id, name)
                                  navigate(path)
                                  setCurrentPath(['dashboard', id])
                                }}
                              >
                                <Image boxSize={5} p='5px' src='/assets/icons/bulletDrawer.svg' mr={2} />
                                <Text fontWeight='normal' color='brandTextBlack' fontSize='md'>
                                  {name === '' ? 'Untitled' : name}
                                </Text>
                              </Button>
                            ))}
                          </Flex>
                        </AccordionPanel>
                      </>
                    )}
                  </AccordionItem>
                ))}
              </Accordion> */}

              <NavbarButton 
                mt={4}
                isActive={currentPath[0] === 'company-dashboard'} 
                text={'Company Dashboard'} 
                iconSrc={''}
                onClick={() => {
                  navigate(`/${'company-dashboard'}`) 
                  setCurrentPath(['company-dashboard'])
                }}
              />

              <Box mt='auto' />
              <NavbarButton 
                mt={4}
                isActive={false} 
                text={'Logout'} 
                iconSrc={'/assets/icons/logout1.svg'}
                onClick={() => {
                  localStorage.removeItem('token')
                  navigate('/')
                  setCurrentPath('/')
                }}
              />
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <Ask 
        isOpen={searchIsOpen}
        setIsOpen={setSearchIsOpen} 
        onClose={() => setSearchIsOpen(false)} 
      />
      <div
        style={{
          color: 'black',
          position: 'fixed',
          bottom: '10px',
          left: '10px',
          zIndex: '100',
        }}
      >
        {currentStep !== -1 && user && user.role && getStarted && (
          <GetStarted openAskArrowhead={() => setSearchIsOpen(true)} />
        )}
      </div>
      <Outlet />
    </>
  )
}
 
export default NavbarLayout